import { isBrowserEnvironment } from './isBrowserEnvironment';

export function getMediaQueryList(query) {
    if (!isBrowserEnvironment() || typeof window.matchMedia !== 'function') {
        return null;
    }
    return window.matchMedia(query);
}

export function subscribeToMediaQuery(mediaQueryList, handler) {
    if (typeof mediaQueryList.addEventListener === 'function') {
        mediaQueryList.addEventListener('change', handler);
        return () => mediaQueryList.removeEventListener('change', handler);
    }

    mediaQueryList.addListener(handler);
    return () => mediaQueryList.removeListener(handler);
}
